import { Icon } from "@mui/material";
import React, { useState } from "react";
import { IColuna } from "../../../types/IColuna";
import { HeadersPesquisarCliente } from "./HeadersPesquisarCliente";
import { MenuColunasPesquisarCliente } from "./MenuColunasPesquisarCliente";
const estiloPesquisarCliente =
  require("../pesquisar-cliente.module.scss").default;

export type TableHeadPesquisarClienteProps = {
  onAlterarFonte: (tamanho: number) => void;
  tamanhoFonte: number;
  colunas: IColuna[];
  onToggleColunaSelecionada: (colunas: IColuna[]) => void;
};

export const TableHeadPesquisarCliente = (
  props: TableHeadPesquisarClienteProps
) => {
  const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false);
  const [icon, setIcon] = useState<string>("arrow_drop_up");

  return (
    <>
      <div className={estiloPesquisarCliente.menu}>
        <button
          style={{ marginLeft: "14px", height: "20px" }}
          id="table-head__grid-itens__arrow"
          className="no-global-button"
          onClick={() => {
            setMostrarFerramentas(!mostrarFerramentas);
            setIcon(
              icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up"
            );
          }}
        >
          <Icon>{icon}</Icon>
        </button>
        {mostrarFerramentas && (
          <section>
            <div className="no-global-button">
              <MenuColunasPesquisarCliente
                colunas={props.colunas}
                onToggleColunaSelecionada={props.onToggleColunaSelecionada}
              />
            </div>
            <div>
              <button
                className={`no-global-button ${estiloPesquisarCliente.botao}`}
                onClick={() => props.onAlterarFonte(props.tamanhoFonte + 1)}
                disabled={props.tamanhoFonte >= 26}
              >
                A+
              </button>
              <button
                className={`no-global-button ${estiloPesquisarCliente.botao}`}
                onClick={() => props.onAlterarFonte(props.tamanhoFonte - 1)}
                disabled={props.tamanhoFonte <= 8}
              >
                A-
              </button>
            </div>
          </section>
        )}
      </div>
      <HeadersPesquisarCliente colunas={props.colunas} />
    </>
  );
};
